import { getCurrentSubWebsite, SubWebsiteOrigin } from "@app/globals";

export const useSubWebsite = (): SubWebsiteOrigin[keyof SubWebsiteOrigin] => {
	return getCurrentSubWebsite();
};
